
import GenericApi from "@/custolink-transpiled_by_server/GenericApi";

// @ts-expect-error yes should implement all methods, but we only use it once above
const GetPath: GenericApi<string> = {
  get(path: string):string {
    return "/"+path
  },
};

export default GetPath
